if (!customElements.get('pfd-header')) {
  customElements.define('pfd-header', class extends HTMLElement {
    connectedCallback() {
      this.events = new AbortController();
      const options = { signal: this.events.signal };
      this.querySelectorAll('details').forEach(details => {
        details.addEventListener('toggle', () => {
          if (!details.open) return;
          this.querySelectorAll('details[open]').forEach(other => {
            if (other !== details && !other.contains(details) && !details.contains(other)) other.open = false;
          });
        }, options);
      });
      this.addEventListener('keydown', event => {
        if (event.key !== 'Escape') return;
        const opened = event.target.closest('details[open]');
        if (opened) {
          opened.open = false;
          opened.querySelector('summary').focus();
          event.stopPropagation();
        }
      }, options);
      document.addEventListener('click', event => {
        if (!this.contains(event.target)) this.closePanels();
      }, options);
      this.addEventListener('focusout', () => {
        requestAnimationFrame(() => {
          if (this.isConnected && !this.contains(document.activeElement)) this.closePanels();
        });
      }, options);
      this.querySelector('[data-pfd-cart]')?.addEventListener('click', event => {
        const drawer = document.getElementById('cart_drawer');
        if (typeof drawer?.openCart === 'function') {
          event.preventDefault();
          this.closePanels();
          drawer.openCart(event);
        }
      }, options);
      this.breakpoint = window.matchMedia('(min-width: 990px)');
      this.breakpoint.addEventListener('change', () => this.closePanels(), options);
    }
    closePanels() {
      this.querySelectorAll('details[open]').forEach(details => { details.open = false; });
    }
    disconnectedCallback() {
      this.events?.abort();
    }
  });
}
